import { useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import AppContext from "./components/contexts/AppContext";
import { ModalContext } from "./components/contexts/ModalContext";

import SideNav from "./components/Account/SideNav";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ClientTable from "./pages/ClientTable";
import Welcome from "./pages/Welcome";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Company from "./pages/Company";
import CheckOut from "./pages/CheckOut";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import ProtectedRoute from "./components/ProtectedRoute";
import StudioHome from "./components/Studio/StudioHome";
import SuperAdminLogin from "./pages/SuperAdminLogin";
import ImpersonateLogin from "./pages/ImpersonateLogin";

// ✅ Toastify import
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Test from "./components/Test";
import NetworkPopup from "./components/NetworkPopup";
import ForgotPassword from "./pages/ForgotPassword";

function App() {
  const [modalData, setModalData] = useState({ currentGalleryName: null });
  const [isModalOpen, setModalOpen] = useState({ type: null, isOpen: false });

  return (
    <div className="App" style={{ userSelect: "none" }}>
      
      <AppContext>
        <ModalContext.Provider
          value={{
            val2: [isModalOpen, setModalOpen],
            modalData: [modalData, setModalData],
          }}
        >
          <BrowserRouter>
            <NetworkPopup/>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Login />} >
               <Route path="/test" element={<Test />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/company" element={<Company />} />
              </Route>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/vidmantra-superadmin/login" element={<SuperAdminLogin />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/vidmantra-superadmin/clientdata" element={<ClientTable />} />
              <Route path="/checkout" element={<CheckOut />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/cancel" element={<CancelPage />} />
              <Route path="/impersonate-login" element={<ImpersonateLogin />} />

              {/* Protected Routes */}
              <Route
                path="/studio/galleries"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/studio/account/:section"
                element={
                  <ProtectedRoute>
                    <SideNav />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/studio/galleries/:galleryId/:section"
                element={
                  <ProtectedRoute>
                    <StudioHome />
                  </ProtectedRoute>
                }
              />

              {/* 404 Fallback */}
              <Route path="*" element={<h1>404 - Page Not Found</h1>} />
            </Routes>
          </BrowserRouter>

          {/* ✅ Toast container global rakha hai */}
       
        </ModalContext.Provider>
           <ToastContainer   />
      </AppContext>
    </div>
  );
}

export default App;
